import React from "react";

import EventCalendar from "../../components/calendar/event-calendar";
import WideLayout from "../../layouts/wide-layout";
import { CalendarContextProvider } from "./calendar-context";

const CalendarPage: React.FC = () => {

  return (
    <WideLayout lockToViewport>
      <CalendarContextProvider>
        <EventCalendar />
      </CalendarContextProvider>
    </WideLayout>
  );
};

export default CalendarPage;
